import * as type from './types';

export function getProfileEditData(data) {
    return {
        type: type.GET_PROFILE_EDIT_DATA_REQUESTED,
        data: data,
    }
}